// Services
import { getUserId } from "app/services/LoginService";

const relayScheduleFormConfig = ({ mode } = {}) => {
	if (!mode || mode === "EDIT") {
		return {
			items: [
				{
					type: "section",
					label: "Schedule Information",
					section: { classes: { label: " -mt-1 " } },
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "schedule_name",
								type: "text",
								label: "Schedule Name",
								required: true,
								placeholder: "Enter schedule name (e.g., Pickup Schedule A)",
							},
							{
								key: "schedule_type",
								type: "select",
								label: "Schedule Type",
								required: true,
								options: [
									{ value: "PICKUP", label: "Pickup" },
									{ value: "DELIVERY", label: "Delivery" },
									{ value: "LONGHAUL", label: "Long Haul" },
								],
								defaultValue: "PICKUP",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "priority",
								type: "select",
								label: "Priority",
								options: [
									{ value: 1, label: "High (1)" },
									{ value: 2, label: "Medium-High (2)" },
									{ value: 3, label: "Medium (3)" },
									{ value: 4, label: "Medium-Low (4)" },
									{ value: 5, label: "Low (5)" },
								],
								defaultValue: 1,
							},
							{
								key: "status",
								type: "select",
								label: "Status",
								options: [
									{ value: "ACTIVE", label: "Active" },
									{ value: "INACTIVE", label: "Inactive" },
									{ value: "MAINTENANCE", label: "Maintenance" },
								],
								defaultValue: "ACTIVE",
							},
						],
					},
				},
				{
					type: "section",
					label: "Origin Configuration",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "origin_type",
								type: "select",
								label: "Origin Type",
								required: true,
								options: [
									{ value: "YARD", label: "Specific Yard" },
									{ value: "FLEXIBLE", label: "Flexible Location" },
								],
								defaultValue: "YARD",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "origin_yard",
								type: "autocomplete",
								label: "Origin Yard",
								required: true,
								autocomplete: {
									provider: "smarthop",
									url: "api/profile/carriers/:carrierId/yards",
									multiple: false,
									preloadDefault: true,
									listenEvent: "profileRevision",
								},
								rules: {
									hidden: [{ fieldKey: "origin_type", noEqualsTo: "YARD" }],
								},
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "origin_coordinates.lat",
								type: "number",
								label: "Origin Latitude",
								placeholder: "Enter latitude",
								rules: {
									hidden: [{ fieldKey: "origin_type", noEqualsTo: "YARD" }],
								},
							},

							{
								key: "origin_coordinates.long",
								type: "number",
								label: "Origin Longitude",
								placeholder: "Enter longitude",
								rules: {
									hidden: [{ fieldKey: "origin_type", noEqualsTo: "YARD" }],
								},
							},
						],
					},
				},
				{
					type: "section",
					label: "Destination Configuration",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "destination_type",
								type: "select",
								label: "Destination Type",
								required: true,
								options: [
									{ value: "YARD", label: "Specific Yard" },
									{ value: "FLEXIBLE", label: "Flexible Location" },
								],
								defaultValue: "YARD",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "destination_yard",
								type: "autocomplete",
								label: "Destination Yard",
								autocomplete: {
									provider: "smarthop",
									url: "api/profile/carriers/:carrierId/yards",
									multiple: false,
									preloadDefault: true,
									listenEvent: "profileRevision",
								},
								rules: {
									hidden: [{ fieldKey: "destination_type", noEqualsTo: "YARD" }],
								},
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "destination_coordinates.lat",
								type: "number",
								label: "Destination Latitude",
								placeholder: "Enter latitude",
								rules: {
									hidden: [{ fieldKey: "destination_type", noEqualsTo: "YARD" }],
								},
							},
							{
								key: "destination_coordinates.long",
								type: "number",
								label: "Destination Longitude",
								placeholder: "Enter longitude",
								rules: {
									hidden: [{ fieldKey: "destination_type", noEqualsTo: "YARD" }],
								},
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "max_radius_miles",
								type: "number",
								label: "Max Radius (miles)",
								placeholder: "Enter maximum radius for flexible pickup/delivery",
								defaultValue: 150,
								help: "Maximum distance from yard for flexible pickup/delivery operations",
							},
						],
					},
				},
				{
					type: "section",
					label: "Time Window and Days of Week",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "start_time",
								label: "Start Time",
								type: "text",
								required: true,
								placeholder: "06:00",
							},
							{
								key: "estimated_duration_hours",
								type: "number",
								label: "Estimated Duration (hours)",
								placeholder: "6",
								min: 1,
								step: 1,
							},
							{
								key: "end_time",
								label: "End Time",
								type: "text",
								required: true,
								placeholder: "18:00",
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "days_of_week_sunday",
								type: "checkbox",
								label: "Sunday",
								defaultValue: false,
							},
							{
								key: "days_of_week_monday",
								type: "checkbox",
								label: "Monday",
								defaultValue: true,
							},
							{
								key: "days_of_week_tuesday",
								type: "checkbox",
								label: "Tuesday",
								defaultValue: true,
							},
							{
								key: "days_of_week_wednesday",
								type: "checkbox",
								label: "Wednesday",
								defaultValue: true,
							},
							{
								key: "days_of_week_thursday",
								type: "checkbox",
								label: "Thursday",
								defaultValue: true,
							},
							{
								key: "days_of_week_friday",
								type: "checkbox",
								label: "Friday",
								defaultValue: true,
							},
							{
								key: "days_of_week_saturday",
								type: "checkbox",
								label: "Saturday",
								defaultValue: true,
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "run_on_holidays",
								type: "checkbox",
								label: "Run on Holidays",
								defaultValue: false,
								help: "Whether this schedule should run on holidays",
							},
							{
								key: "only_even_weeks",
								type: "checkbox",
								label: "Only Even Weeks",
								defaultValue: false,
								help: "Run only on even-numbered weeks of the year",
							},
							{
								key: "only_odd_weeks",
								type: "checkbox",
								label: "Only Odd Weeks",
								defaultValue: false,
								help: "Run only on odd-numbered weeks of the year",
							},
						],
					},
				},
				{
					type: "section",
					label: "Equipment & Capacity",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "assigned_trucks",
								type: "autocomplete",
								label: "Assigned Trucks",
								help: "Trucks marked 'Relay Off' will not be used in relay operations",
								autocomplete: {
									provider: "smarthop",
									url: "api/profile/carriers/:carrierId/trucks",
									multiple: true,
									preloadDefault: true,
									listenEvent: "profileRevision",
									showDescription: true,
								},
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "max_concurrent_loads",
								type: "number",
								label: "Max Concurrent Loads",
								placeholder: "How many loads can run simultaneously",
								defaultValue: 1,
								min: 1,
							},
						],
					},
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "buffer_time_minutes",
								type: "number",
								label: "Buffer Time (minutes)",
								placeholder: "Buffer between operations",
								defaultValue: 30,
								min: 0,
							},
						],
					},
				},
				{
					type: "section",
					label: "Additional Information",
				},
				{
					type: "group",
					content: {
						items: [
							{
								key: "notes",
								type: "text",
								label: "Notes",
								placeholder: "Additional information about this schedule",
								multiline: { rows: 4 },
							},
						],
					},
				},
				{ type: "action", action: "SUBMIT" },
			],
		};
	} else if (mode === "VIEW") {
		return {
			info: {
				items: [
					{
						key: "schedule_name",
						type: "text",
						label: "Schedule Name",
					},
					{
						key: "schedule_type",
						type: "text",
						label: "Schedule Type",
					},
					{
						key: "status",
						type: "text",
						label: "Status",
					},
					{
						key: "priority",
						type: "text",
						label: "Priority",
					},
					{
						key: "origin_type",
						type: "text",
						label: "Origin Type",
					},
					{
						key: "destination_type",
						type: "text",
						label: "Destination Type",
					},
					{
						key: "max_radius_miles",
						type: "number",
						label: "Max Radius (miles)",
					},
					{
						key: "equipment_types",
						type: "array",
						label: "Equipment Types",
					},
					{
						key: "max_concurrent_loads",
						type: "number",
						label: "Max Concurrent Loads",
					},
					{
						key: "estimated_duration_hours",
						type: "number",
						label: "Estimated Duration (hours)",
					},
					{
						key: "buffer_time_minutes",
						type: "number",
						label: "Buffer Time (minutes)",
					},
					{
						key: "run_on_holidays",
						type: "text",
						label: "Run on Holidays",
					},
					{
						key: "only_even_weeks",
						type: "text",
						label: "Only Even Weeks",
					},
					{
						key: "only_odd_weeks",
						type: "text",
						label: "Only Odd Weeks",
					},
					{
						key: "notes",
						type: "textarea",
						label: "Notes",
					},
				],
			},
		};
	}
};

const relayScheduleForm = ({ user } = {}) => {
	return {
		urlPOST: "api/profile/carriers/:carrierId/relay-schedules",
		urlGET: "api/profile/carriers/:carrierId/relay-schedules/:id",
		urlPUT: "api/profile/carriers/:carrierId/relay-schedules/:id",
		idKey: "_id",
		triggerEvent: ["relayScheduleRevision", "profileRevision", "dataRevision"],
		listenEvent: "relayScheduleRevision",
		header: {
			create: { label: "Add New Relay Schedule" },
			edit: { label: "Edit Relay Schedule" },
			delete: { label: "Delete Relay Schedule" },
			view: { label: "View Relay Schedule" },
		},
		messages: {
			edit: { success: "Successfully Saved Relay Schedule" },
			create: { sameAs: "edit" },
		},
		content: {
			delete: {
				items: [
					{
						type: "message",
						builder: (item) => `Would you like to permanently delete relay schedule '${item.schedule_name}'?`,
					},
					{
						type: "group",
						content: {
							items: [
								{ type: "action", action: "CANCEL" },
								{ type: "action", action: "DELETE" },
							],
						},
					},
				],
			},
			view: {
				sameAs: "edit",
			},
			create: {
				...relayScheduleFormConfig({ mode: "EDIT" }),
			},
			edit: relayScheduleFormConfig({ mode: "EDIT" }),
		},
	};
};

export { relayScheduleForm, relayScheduleFormConfig };
